<script>
export default {
  name: 'CtaBuyBook',

  props: {
    label: String,
    title: String,
    link: String,
    linkLabel: String,
    content: String,
    showForm: Boolean,
    countriesList: Array,

    classes: {
      default: '',
      type: String,
    },
  },

  methods: {
    openModal() {
      this.$root.openBuyBookModal({
        title: this.title,
        content: this.content,
        link: this.link,
        linkLabel: this.linkLabel,
        showForm: this.showForm,
        countriesList: this.countriesList,
      })
    },
  },
}
</script>

<template>
  <button
    :class="classes"
    class="btn mb-8"
    @click="openModal">
    {{ label }}
  </button>
</template>
